import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from "../../api/axiosInstance";

import iconImg from "../../assets/image/swc.png";

const ForgetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    user_name: location.state?.user_name || "", // Pre-fill if passed from previous page
    password: "",
    confirm_password: "",
  });



  // Form field change handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Form validation
  const validateForm = () => {
    const {
      user_name,
      password,
      confirm_password,
    } = formData;
    const newErrors = {};

    if (!user_name) {
      newErrors.user_name = "กรุณากรอก Username";
    } else if (/[\u0E00-\u0E7F]/.test(user_name)) {
      newErrors.user_name = "ห้ามมีตัวอักษรภาษาไทย";
    } else if (/[A-Z]/.test(user_name)) {
      newErrors.user_name = "ต้องเป็นตัวพิมพ์เล็กเท่านั้น";
    }

    if (!password) newErrors.password = "กรุณากรอก Password";
    if (!confirm_password) {
      newErrors.confirm_password = "กรุณากรอก Confirm Password";
    } else if (password !== confirm_password) {
      newErrors.confirm_password = "Password และ Confirm Password ต้องตรงกัน";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Submit handler
  const handleSubmit = async () => {
    if (!validateForm()) return;

    const payload = {
      user_name: formData.user_name,
      password: formData.password,
    };

    try {
      const response = await api.post("/api/member/forget-password", payload);


      // Check server response
      if (response.status === 200 || response.status === 201) {
        const { message } = response.data; // depends on server response structure
        toast.success(message || "รีเซ็ตรหัสผ่านสำเร็จ");

        // Redirect after a short delay
        // setTimeout(() => navigate("/"), 3000);
      } else {
        toast.error(response.data?.message || "เกิดข้อผิดพลาดในการรีเซ็ตรหัสผ่าน");
      }
    } catch (error) {
      console.error("Axios error:", error);

      // Handle errors from server
      if (error.response) {
        // Server responded with a status code outside 2xx
        toast.error(
          error.response.data?.message ||
            `Server error ${error.response.status}`
        );
      } else {
        // Other errors
        toast.error(`เกิดข้อผิดพลาด: ${error.message}`);
      }
    }
  };

  return (
    <Box
      sx={{
        width: "99vw",
        height: "97vh",
        display: "flex",
        backgroundColor: "#80BDB6",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
    >
      {/* Logo */}
      <Box sx={{ position: "absolute", top: 16, left: 16 }}>
        <img src={iconImg} alt="logo-top" style={{ width: 100, height: 100 }} />
      </Box>

      {/* Register Form */}
      <Paper
        elevation={4}
        sx={{
          padding: 3,
          width: "40%",
          maxHeight: "85vh",
          overflowY: "auto",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          gap: 2,
          borderRadius: "20px",
          backgroundColor: "#C8EAE6",
        }}
      >
        <Typography variant="h6" fontWeight="bold">
          รีเซ็ตรหัสผ่าน
        </Typography>

        {/* Input Fields */}
        {[
          { label: "Username", name: "user_name" },
          { label: "Password", name: "password", type: "password" },
          {
            label: "Confirm Password",
            name: "confirm_password",
            type: "password",
          },
        ].map((field) => (
          <TextField
            key={field.name}
            variant="outlined"
            label={field.label}
            name={field.name}
            type={field.type || "text"}
            value={formData[field.name]}
            onChange={handleChange}
            error={Boolean(errors[field.name])}
            helperText={errors[field.name] || ""} // Show error under field
            sx={{
              width: "90%",
              "& .MuiOutlinedInput-root": {
                borderRadius: "20px",
                backgroundColor: "#fff",
              },
            }}
          />
        ))}

        {/* Action Buttons */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: 2,
            width: "60%",
          }}
        >
          <Button
            variant="contained"
            sx={{
              borderRadius: "20px",
              backgroundColor: "#368D83",
              color: "#fff",
              flex: 1,
              mr: 1,
            }}
            onClick={handleSubmit}
          >
            รีเซ็ตรหัสผ่าน
          </Button>
          <Button
            variant="outlined"
            sx={{
              backgroundColor: "#368D83",
              borderRadius: "20px",
              borderColor: "#368D83",
              color: "#368D83",
              backgroundColor: "rgba(255, 255, 255, 0.6)",
                "&:hover": {
                  borderColor: "#286961",
                  color: "#286961",
                  backgroundColor: "rgba(54, 141, 131, 0.08)",
                },
              flex: 1,
              ml: 1,
            }}
            onClick={() => navigate("/login")}
          >
            ย้อนกลับ
          </Button>
        </Box>
      </Paper>

    </Box>
  );
};

export default ForgetPassword;
